import { render, staticRenderFns } from "./upgradefdForm.vue?vue&type=template&id=6b525690&"
import script from "./upgradefdForm.vue?vue&type=script&lang=js&"
export * from "./upgradefdForm.vue?vue&type=script&lang=js&"
import style0 from "./upgradefdForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upgradefdForm.vue"
export default component.exports